import { AppV2 } from "src/models/appV2";
import { createEntityModel } from "src/store/models/entity/_shared";

export const AppEntityModel = createEntityModel<AppV2>();
